import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { handleVerificationFormPost } from "../commonHandlerFunction/sampleVerificationHandlerFunctions";
import PropTypes from 'prop-types';
import { decryptDataForURL, encryptDataForURL } from "../../../utills/useCryptoUtils";
import { useNavigate } from "react-router-dom";
import { handleSFMFinalPostWithAmendement } from "../commonHandlerFunction/intenralCertificateHandlerFunction";


const SFMButtons = ({
  setIsPopupOpen,
  setJRFCreationType,
  handleSubmit,
  saveClicked,
  formData,
  viewOnly,
  testMemoSetData,
  handleBackButtonFunction,
  setIsOverlayLoader
}) => {
  const { t } = useTranslation();
  const translate = t;
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const is_amendment = decryptDataForURL(params.get("is_amendment"))
  const amend_type = decryptDataForURL(params.get("amend_type"))
  const ic_id = decryptDataForURL(params.get("ic_id"))
  const navigate = useNavigate();
  const getTotalNotFilledCount = () => {
    let count = 0;
    testMemoSetData.forEach((tab, tabIndex) => {
      count += formData["tab_" + tabIndex]?.["noFilledCount"];
    });
    return count;
  };

  return (
    <div className="submit_btns">
      {" "}
      <Button
        type="button"
        className="saveBtn"
        id="submit_btn3"
        onClick={() => {
          is_amendment ? navigate(-1) : handleBackButtonFunction()
        }}
      >
        {translate("common.backBtn")}
      </Button>
      {!viewOnly && !getTotalNotFilledCount() && !is_amendment && (
        <button
          type="button"
          className="submitBtn"
          id="submit_btn3"
          data-name="save"
          onClick={(e) =>
            handleVerificationFormPost(
              e,
              handleSubmit,
              setJRFCreationType,
              setIsPopupOpen
            )
          }
        >
          {translate("common.postBtn")}
        </button>
      )}
      {
        !viewOnly && is_amendment && (
          <button
            type="button"
            className="submitBtn"
            id="submit_btn3"
            data-name="save"
            onClick={(e) => {
              // amend_type === "SFM" ? handleSFMFinalPostWithAmendement(setIsOverlayLoader,navigate): navigate(`/testReport/test-results?editId=${encryptDataForURL(ic_id)}&is_amendment=${encryptDataForURL('true')}&status=${encryptDataForURL('testmemoresult')}`)
              // amend_type === "SFM" ? handleSFMFinalPostWithAmendement(setIsOverlayLoader, formData, "pending", "amendment in-process", () => {
              //   navigate(`/SFMList`)
              // }) : navigate(`/SFMList`)
              let status = amend_type === "SFM" ? "pending" : "saved"
              let mainstatus = amend_type === "SFM" ? "amendment in-process" : "amendment saved"
              handleSFMFinalPostWithAmendement(setIsOverlayLoader, formData, status, mainstatus, () => {
                navigate(`/SFMList`)
              }, true)
            }
            }
          >
            {/* {amend_type === "SFM" ? 'Post' : 'Edit Certificate Details'} */}
            Post
          </button>
        )
      }
    </div>
  );
};

SFMButtons.propTypes = {
  setIsPopupOpen: PropTypes.func,
  setJRFCreationType: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  saveClicked: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  handleBackButtonFunction: PropTypes.func.isRequired,

  viewOnly: PropTypes.bool.isRequired,
  testMemoSetData: PropTypes.func.isRequired,
};
export default SFMButtons;